import { useState } from 'react';
import DatePicker from '../../components/DatePicker';
import { useKapatma } from '../../context/KapatmaContext';
import YilDropdown from '../../components/YilDropdown';

const AYLAR = [
  { kisa: 'Oca', tam: 'Ocak', no: 0 },
  { kisa: 'Şub', tam: 'Şubat', no: 1 },
  { kisa: 'Mar', tam: 'Mart', no: 2 },
  { kisa: 'Nis', tam: 'Nisan', no: 3 },
  { kisa: 'May', tam: 'Mayıs', no: 4 },
  { kisa: 'Haz', tam: 'Haziran', no: 5 },
  { kisa: 'Tem', tam: 'Temmuz', no: 6 },
  { kisa: 'Ağu', tam: 'Ağustos', no: 7 },
  { kisa: 'Eyl', tam: 'Eylül', no: 8 },
  { kisa: 'Eki', tam: 'Ekim', no: 9 },
  { kisa: 'Kas', tam: 'Kasım', no: 10 },
  { kisa: 'Ara', tam: 'Aralık', no: 11 },
];

const GUN_ADLARI = ['Pzr', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'];
const HAFTASONU = [0, 6]; // Pazar, Cumartesi

// Örnek oda tipleri
const ODA_TIPLERI = ['Standart', 'Deluxe', 'Suite', 'Superior'];

// DD.MM.YYYY → Date
function parseDate(str) {
  if (!str) return null;
  var p = str.split('.');
  if (p.length !== 3) return null;
  return new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0]));
}

// Date → DD.MM.YYYY
function formatDate(d) {
  return [
    String(d.getDate()).padStart(2, '0'),
    String(d.getMonth() + 1).padStart(2, '0'),
    d.getFullYear(),
  ].join('.');
}

// Bugün DD.MM.YYYY
function bugunStr() {
  return formatDate(new Date());
}

// Ayın son günü DD.MM.YYYY
function ayinSonGunu(yil, ayNo) {
  return formatDate(new Date(yil, ayNo + 1, 0));
}

// Ayın ilk günü DD.MM.YYYY
function ayinIlkGunu(yil, ayNo) {
  return formatDate(new Date(yil, ayNo, 1));
}

// İki tarih arasındaki tüm günleri döndür
function gunAraligi(baslangic, bitis) {
  var gunler = [];
  var cur = new Date(baslangic);
  var end = new Date(bitis);
  while (cur <= end) {
    gunler.push(new Date(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return gunler;
}

// Örnek oda/rate verileri
const ODALAR = [
  {
    id: 1,
    ad: 'Standard Room',
    rates: [
      { id: 1, ad: 'RO – Standard Rate' },
    ],
  },
];

// ── Kanallara Gönder Modal ──
function KanallaragonderModal({ onClose }) {
  var [secim, setSecim] = useState('musaitlik');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[70] flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-gray-800 tracking-wide">KANALLARA GÖNDER</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl font-bold w-8 h-8 flex items-center justify-center">✕</button>
        </div>
        <div className="px-6 py-6 space-y-3">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="gonderTip"
              value="fiyat"
              checked={secim === 'fiyat'}
              onChange={function() { setSecim('fiyat'); }}
              className="w-4 h-4 accent-blue-600"
            />
            <span className="text-sm text-gray-700">Fiyatları gönder</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="gonderTip"
              value="musaitlik"
              checked={secim === 'musaitlik'}
              onChange={function() { setSecim('musaitlik'); }}
              className="w-4 h-4 accent-blue-600"
            />
            <span className="text-sm text-gray-700">Müsaitlikleri gönder</span>
          </label>
        </div>
        <div className="px-6 pb-6">
          <button
            onClick={function() {
              alert((secim === 'fiyat' ? 'Fiyatlar' : 'Müsaitlikler') + ' kanallara gönderildi.');
              onClose();
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg text-sm tracking-wider transition-colors">
            GÖNDER
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Satışa Kapat Modal ──
function SatisaKapatModal({ onClose, kapatmalar, onEkle, onSil }) {
  var bugun = bugunStr();
  var [basDate, setBasDate] = useState(bugun);
  var [bitDate, setBitDate] = useState(bugun);
  var [odaTip, setOdaTip] = useState('Standart');

  function ekle() {
    if (!basDate || !bitDate) return;
    onEkle({ id: Date.now(), bas: basDate, bit: bitDate, odaTip: odaTip });
  }

  function reselivayaGonder(kayit) {
    alert(kayit.bas + ' – ' + kayit.bit + ' tarihleri arası "' + kayit.odaTip + '" odası Reseliva\'ya gönderildi.');
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[70] flex items-start justify-center pt-10">
      <div className="bg-white w-full max-w-5xl mx-4 rounded-xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-gray-800">Satışa kapat</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl font-bold w-8 h-8 flex items-center justify-center">✕</button>
        </div>

        {/* Ekleme formu */}
        <div className="px-6 py-5 border-b border-gray-100">
          <div className="flex items-end gap-4 flex-wrap">
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Başlangıç tarih</label>
              <DatePicker value={basDate} onChange={setBasDate} className="w-40" />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Bitiş tarih</label>
              <DatePicker value={bitDate} onChange={setBitDate} minDate={basDate} className="w-40" />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Oda tip</label>
              <div className="relative">
                <select
                  value={odaTip}
                  onChange={function(e) { setOdaTip(e.target.value); }}
                  className="border border-gray-200 rounded-xl px-3 py-2 pr-8 text-sm bg-gray-50 text-gray-700 focus:outline-none appearance-none cursor-pointer w-36">
                  {ODA_TIPLERI.map(function(o) { return <option key={o}>{o}</option>; })}
                </select>
                <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
              </div>
            </div>
            <button
              onClick={ekle}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors">
              Ekle
            </button>
          </div>
        </div>

        {/* Kayıt listesi */}
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50">
                <th className="text-left py-3 px-4 font-semibold text-gray-600">Gönder</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">Baş. tarih</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">Bit. tarih</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">Fiyat</th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">Sil</th>
              </tr>
            </thead>
            <tbody>
              {kapatmalar.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-8 text-gray-400">Kayıt yok</td></tr>
              ) : kapatmalar.map(function(k) {
                return (
                  <tr key={k.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4">
                      <button
                        onClick={function() { reselivayaGonder(k); }}
                        className="bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold px-4 py-1.5 rounded-lg transition-colors whitespace-nowrap">
                        Reselivaya gönder »
                      </button>
                    </td>
                    <td className="py-3 px-4 text-gray-700">{k.bas}</td>
                    <td className="py-3 px-4 text-gray-700">{k.bit}</td>
                    <td className="py-3 px-4 text-gray-700">{k.odaTip}</td>
                    <td className="py-3 px-4">
                      <button
                        onClick={function() { onSil(k.id); }}
                        className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold px-3 py-1.5 rounded-lg transition-colors">
                        Sil
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ── Ana Sayfa ──
export default function FiyatVeMüsaitlik() {
  var simdi = new Date();
  var [secilenYil, setSecilenYil] = useState(simdi.getFullYear());
  var [secilenAy, setSecilenAy] = useState(simdi.getMonth());

  // Tarih filtreleri
  var ilkGun = ayinIlkGunu(secilenYil, secilenAy);
  var sonGun = ayinSonGunu(secilenYil, secilenAy);
  var [basTarih, setBasTarih] = useState(ilkGun);
  var [bitTarih, setBitTarih] = useState(sonGun);

  var [kanalModal, setKanalModal] = useState(false);
  var [satisModal, setSatisModal] = useState(false);

  // Satışa kapatma kayıtları — global context'ten
  var { kapatmalar, kapatmaEkle, kapatmaSil } = useKapatma();

  // Belirli bir gün için satışa kapalı mı?
  function isKapali(gun, odaAdi) {
    var gunD = new Date(gun.getFullYear(), gun.getMonth(), gun.getDate());
    return kapatmalar.some(function(k) {
      var basD = parseDate(k.bas);
      var bitD = parseDate(k.bit);
      if (!basD || !bitD) return false;
      var bas = new Date(basD.getFullYear(), basD.getMonth(), basD.getDate());
      var bit = new Date(bitD.getFullYear(), bitD.getMonth(), bitD.getDate());
      return gunD >= bas && gunD <= bit;
    });
  }

  // Ay seçilince tarihleri güncelle
  function ayBas(ayNo) {
    setSecilenAy(ayNo);
    var ilk = ayinIlkGunu(secilenYil, ayNo);
    var son = ayinSonGunu(secilenYil, ayNo);
    setBasTarih(ilk);
    setBitTarih(son);
  }

  // Başlangıç tarihi değişince bitiş tarihi geride kalmasın
  function handleBasTarihChange(val) {
    setBasTarih(val);
    var bas = parseDate(val);
    var bit = parseDate(bitTarih);
    if (bas && bit && bas > bit) {
      setBitTarih(val);
    }
  }

  // Görüntülenecek günler
  var gunler = [];
  var bas = parseDate(basTarih);
  var bit = parseDate(bitTarih);
  if (bas && bit && bas <= bit) {
    gunler = gunAraligi(bas, bit);
  }

  // Hafta sonu kontrolü
  function isHaftasonu(d) { return HAFTASONU.includes(d.getDay()); }
  function isBugun(d) {
    var t = new Date();
    return d.getDate() === t.getDate() && d.getMonth() === t.getMonth() && d.getFullYear() === t.getFullYear();
  }

  return (
    <div className="p-6 space-y-4">
      {/* Başlık & butonlar */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-lg font-bold text-gray-800">Fiyat ve müsaitlik</h1>
        <div className="flex gap-2">
          <button
            onClick={function() { setKanalModal(true); }}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors">
            <span>✈</span> KANALLARA GÖNDER
          </button>
          <button
            onClick={function() { setSatisModal(true); }}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors">
            Satışa kapat
          </button>
          <button className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors">
            Yenile
          </button>
        </div>
      </div>

      {/* Yıl seçici + Ay butonları */}
      <div className="flex items-center gap-2 flex-wrap">
        <YilDropdown value={secilenYil} onChange={function(y) { setSecilenYil(y); ayBas(secilenAy); }} />

        {AYLAR.map(function(a) {
          var aktif = a.no === secilenAy;
          return (
            <button
              key={a.no}
              onClick={function() { ayBas(a.no); }}
              className={'px-4 py-2 rounded-lg text-sm font-semibold transition-colors ' +
                (aktif
                  ? 'bg-indigo-600 text-white'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700')}>
              {a.kisa}
            </button>
          );
        })}
      </div>

      {/* Tarih aralığı seçici */}
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <DatePicker
            value={basTarih}
            onChange={handleBasTarihChange}
            className="w-40"
          />
          <span className="text-gray-400">–</span>
          <DatePicker
            value={bitTarih}
            onChange={setBitTarih}
            minDate={basTarih}
            className="w-40"
          />
        </div>
      </div>

      {/* Açıklama */}
      <div className="text-xs text-gray-500 font-medium">
        M : Müsait / F : Fiyat / SK : Satışa kapalı
      </div>

      {/* Tablo */}
      {gunler.length === 0 ? (
        <div className="text-center py-16 text-gray-400">Geçerli bir tarih aralığı seçiniz</div>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
          <table className="border-collapse text-xs min-w-full">
            <thead>
              <tr className="bg-blue-600">
                {/* Boş köşe */}
                <th className="sticky left-0 z-10 bg-blue-600 w-44 min-w-44 border-r border-blue-500 py-2 px-3 text-left text-white font-semibold" />
                {gunler.map(function(gun, i) {
                  var haftasonu = isHaftasonu(gun);
                  var bugunMu = isBugun(gun);
                  var bgClass = bugunMu ? 'bg-red-500' : haftasonu ? 'bg-red-400' : 'bg-blue-600';
                  return (
                    <th key={i} className={'min-w-16 border-r border-blue-500 py-1 px-1 text-center text-white font-semibold ' + bgClass}>
                      <div className="text-xs opacity-80">{AYLAR[gun.getMonth()].kisa}</div>
                      <div className="text-sm font-bold">{gun.getDate()}</div>
                      <div className="text-xs opacity-80">{GUN_ADLARI[gun.getDay()]}</div>
                      {(haftasonu || bugunMu) && (
                        <div className="text-yellow-300 text-xs">★</div>
                      )}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {ODALAR.map(function(oda) {
                return [
                  // Oda başlık satırı
                  <tr key={'oda-' + oda.id} className="bg-white border-b border-gray-200">
                    <td className="sticky left-0 z-10 bg-white border-r border-gray-200 py-2 px-3 font-bold text-gray-800 text-sm">
                      {oda.ad}
                    </td>
                    {gunler.map(function(gun, i) {
                      var haftasonu = isHaftasonu(gun);
                      var kapali = isKapali(gun, oda.ad);
                      return (
                        <td key={i} className={'border-r border-gray-100 py-2 px-1 text-center font-medium ' + (kapali ? 'bg-red-100' : haftasonu ? 'bg-red-50' : '')}>
                          {kapali ? (
                            <span className="text-red-700 font-bold flex items-center justify-center gap-0.5">
                              🔒 SK
                            </span>
                          ) : (
                            <span className="text-green-600">M : 0</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>,
                  // Rate planı satırları
                  ...oda.rates.map(function(rate) {
                    return (
                      <tr key={'rate-' + rate.id} className="bg-gray-50 border-b border-gray-200">
                        <td className="sticky left-0 z-10 bg-gray-50 border-r border-gray-200 py-2 px-3 text-gray-600 flex items-center gap-1">
                          <span className="text-gray-400 text-xs">✏</span>
                          {rate.ad}
                        </td>
                        {gunler.map(function(gun, i) {
                          var haftasonu = isHaftasonu(gun);
                          var kapali = isKapali(gun, oda.ad);
                          return (
                            <td key={i} className={'border-r border-gray-100 py-2 px-1 text-center ' + (kapali ? 'bg-red-100' : haftasonu ? 'bg-red-50' : '')}>
                              {kapali ? (
                                <span className="text-red-500 font-bold text-xs">—</span>
                              ) : (
                                <span className="text-blue-600">F : 0</span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  }),
                ];
              })}

              {/* Toplam satırı */}
              <tr className="bg-blue-50 font-bold">
                <td className="sticky left-0 z-10 bg-blue-50 border-r border-gray-200 py-2 px-3 text-blue-700">TOPLAM:</td>
                {gunler.map(function(gun, i) {
                  var haftasonu = isHaftasonu(gun);
                  return (
                    <td key={i} className={'border-r border-gray-100 py-2 px-1 text-center text-blue-700 ' + (haftasonu ? 'bg-red-50' : '')}>
                      M : 0
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Modallar */}
      {kanalModal && <KanallaragonderModal onClose={function() { setKanalModal(false); }} />}
      {satisModal && <SatisaKapatModal onClose={function() { setSatisModal(false); }} kapatmalar={kapatmalar} onEkle={kapatmaEkle} onSil={kapatmaSil} />}
    </div>
  );
}